import { useParams } from 'react-router-dom'
import React from 'react'
import useGetOrderById from '@hooks/useGetOrderById'
import { getFragmentData } from 'parkdepot-shared/gql'
import { OrderResponseFragment } from '@graphql/queries/getOpenOrders.query'
import { Container, SpinnerContainer } from './OrderInfo.style'
import CarpayOrderCard from '@components/CarpayOrderCard/CarpayOrderCard.component'
import CarpayOrderActions from '@components/CarpayOrderActions/CarpayOrderActions.component'
import Spinner from 'parkdepot-shared/components/Spinner'
import Error from '@components/Error/Error.component'
import { useTranslation } from 'react-i18next'

const CarpayOrderInfo = () => {
    const { t } = useTranslation()
    const { order_id } = useParams<{ order_id: string }>()
    const { data, loading, error } = useGetOrderById({
        skip: !order_id,
        fetchPolicy: 'cache-and-network',
        variables: { order_id }
    })

    if (loading) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error) {
        return <Error />
    }

    if (!data?.b2c_get_order_by_id) return <div>{t('carpay.notFound.orderNotFound')}</div>

    const orderResponse = getFragmentData(OrderResponseFragment, data.b2c_get_order_by_id)

    const isActionsSectionShown = orderResponse?.price?.billable

    return (
        <Container>
            <CarpayOrderCard data={orderResponse} isLast={false} onClick={() => null} />

            {isActionsSectionShown && <CarpayOrderActions orderData={orderResponse} />}
        </Container>
    )
}

export default CarpayOrderInfo
